import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { FundDataProvider } from './context/FundDataContext';
import Dashboard from './components/Dashboard';
import Login from './components/Admin';
import Home from './components/Home';
import Letters from './components/Letters';
import Profile from './components/Profile';
import Portfolio from './components/Portfolio';
import FundAdmin from './components/FundAdmin';
import ClientLayout from './components/client/ClientLayout';
import LoadingSpinner from './components/LoadingSpinner';

function AuthGate() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="client-shell" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <LoadingSpinner text="Authenticating..." />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin" replace />;
  }

  return <ClientLayout />;
}

function AdminRoute({ children }) {
  const { isAuthenticated, isLoading, isFundAdmin } = useAuth();

  if (isLoading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f5f6f8',
      }}>
        <LoadingSpinner text="Authenticating..." />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin" replace />;
  }

  if (!isFundAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

function App() {
  return (
    <AuthProvider>
      <FundDataProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Login />} />

          <Route element={<AuthGate />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/letters" element={<Letters />} />
            <Route path="/profile" element={<Profile />} />
          </Route>

          <Route
            path="/fund-admin"
            element={
              <AdminRoute>
                <FundAdmin />
              </AdminRoute>
            }
          />
        </Routes>
      </Router>
      </FundDataProvider>
    </AuthProvider>
  );
}

export default App;
